import {Component, DestroyRef, inject} from '@angular/core';
import {OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsManager} from 'src/app/services/events.manager';
import {HeroComponent} from 'src/app/components/hero/hero.component';
import {NgIf, CommonModule} from '@angular/common';
import {CardItemComponent} from 'src/app/components/card-item/card-item.component';
import {PlansService} from 'src/app/services/plans.service';
import {PhonePipe} from 'src/app/pipes/phone.pipe';
import {FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ValidateEmail} from 'src/app/validators/form-validator';
import {ContactUsRequestInterface} from 'src/app/interfaces/contact-us-request.interface';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {RouterLink} from '@angular/router';
import {MarketingDetailsRequestInterface} from 'src/app/interfaces/marketing-details-request.interface';

@Component({
  selector: 'app-adha',
  imports: [CommonModule, HeroComponent, NgIf, CardItemComponent, FormsModule, ReactiveFormsModule, PhonePipe, RouterLink],
  templateUrl: './adha.component.html',
  styleUrl: './adha.component.scss'
})

export class AdhaComponent implements OnInit {
  protected _eventsManager = inject(EventsManager);
  private _plansService = inject(PlansService);
  private _googleAnalyticsService = inject(GoogleAnalyticsService);
  private _destroyRef = inject(DestroyRef);

  public showDetails: boolean = true;
  public details: any = {};
  public info: any = {};
  public marketingDetails: any = {};
  public showContactSuccess: boolean = false;
  public showContactError: boolean = false;
  public viewSavingsUrl: string = '/summary-of-discounts';
  public planName: string = 'Smile Generation Dental Plan';
  public contactUs: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3)]),
    email: new FormControl('', [Validators.required, ValidateEmail]),
    message: new FormControl('', [Validators.required, Validators.minLength(3)]),
    planName: new FormControl(this._eventsManager.planName),
    planEmail: new FormControl(this._eventsManager.planEmail)
  });

  public ngOnInit(): void {
    this._eventsManager.setHideHeader(true);
    this.getPlansForADHA();
    this._eventsManager.purchaseIsADHA = true;
  }

  public getPlansForADHA() {
    this._plansService.getPlanOptionsByPractice(this._eventsManager.adhaPractice).pipe(takeUntilDestroyed(this._destroyRef)).subscribe((result: any) => {
      this._eventsManager.planOptions = result;
      this.details = result;
      this.getHomePageDetails(this.details?.templates[0].benefitPlanTemplateId);
      this.viewSavingsUrl = '/adha/summary-of-discounts';

      if (result.templates && result.templates.length > 0) {
        this.planName = result.templates[0].planName;
      }
    });
  }

  public sendForm() {
    const request: ContactUsRequestInterface = {name:this.contactUs.get('name')?.value, email:this.contactUs.get('email')?.value, message:this.contactUs.get('message')?.value, planName:this.contactUs.get('planName')?.value, planEmail:this.contactUs.get('planEmail')?.value};
    this._plansService.sendContactUs(request).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(
      () => {
        this.showContactSuccess = true;
        this._googleAnalyticsService.sendKeyEvent('contact_us_submit', {
          timestamp: new Date().toISOString()
        });
      },
      () => {
        this.showContactError = true;
      }
    );
  }

  public getHomePageDetails(planId: string) {
    const request: MarketingDetailsRequestInterface = {pageName: 'home', planId:planId};
    this._plansService.getHomePageData(request).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(
      (result: any) => {
        this._eventsManager.homePageDetails = result;
        this._eventsManager.homePageDetailUpdated.emit();
        this.marketingDetails = result;
      }
    );
  }

  public findDentist() {
    this._googleAnalyticsService.sendKeyEvent('find_dentist', {
      timestamp: new Date().toISOString()
    });
  }
}
